import useCustomNavigate from "../../../common/hooks/useCustomNavigate";

const HeaderTexts = ({ title, subTitle, showRetryButton = false }) => {
    const { navigateToCustom } = useCustomNavigate();

    const handelNavigate = () => navigateToCustom("/home");

    return (
        <div className="d-flex justify-content-between align-items-start mb-3">
            <div>
                <h6 className="mb-1">{title}</h6>
                <p className="text-sm text-secondary mb-0">
                    {subTitle}
                </p>
            </div>

            {showRetryButton && (
                <button
                    type="button"
                    className="btn btn-icon-only btn-rounded btn-outline-secondary btn-sm d-flex align-items-center justify-content-center ms-2"
                    onClick={handelNavigate}
                >
                    <i className="material-symbols-rounded text-sm">
                        refresh
                    </i>
                </button>
            )}
        </div>
    );
};

export default HeaderTexts;